import { render, staticRenderFns } from "./CurriculumMenu.vue?vue&type=template&id=56772757&scoped=true&"
import script from "./CurriculumMenu.vue?vue&type=script&lang=js&"
export * from "./CurriculumMenu.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumMenu.vue?vue&type=style&index=0&id=56772757&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56772757",
  null
  
)

export default component.exports